// extracted by mini-css-extract-plugin
export var aircallIframe = "_n0-3";
export var fabContainer = "_n0-5";
export var fabRinging = "_n0-6";
export var loadingOverlay = "_n0-4";
export var pulse = "_n0-7";
export var widgetContent = "_n0-2";
export var widgetPanel = "_n0-0";
export var widgetPanelExpanded = "_n0-1";